module.exports = __webpack_public_path__ + "img/intro3.0e074a47.jpg";